import {Component, OnDestroy, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FilterBase} from "../../../../../models/filter-base";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {FilterbaseService} from "../../filter-base/services/filterbase.service";

@Component({
    selector: 'app-range-text',
    templateUrl: './range-text.component.html',
    styleUrls: ['./range-text.component.css'],
    standalone: false
})
export class RangeTextComponent implements OnDestroy, OnInit {
  /** Service subscriptions end with the component (they used to leak). */
  private readonly destroy$ = new Subject<void>();
  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  @Input() filterBase!: FilterBase;
  @Output() outValue = new EventEmitter<string>();
  fromValue: string = '';
  toValue: string = '';

  constructor(private filterBaseService: FilterbaseService) { }

  ngOnInit(): void {
    const stored = this.filterBaseService.getQuestion(this.filterBase.key);
    this.fromValue = stored?.from || '';
    this.toValue = stored?.to || '';
    this.filterBaseService.getRemoveEvent().pipe(takeUntil(this.destroy$)).subscribe(key => {
      if (key === this.filterBase.key) { this.fromValue = ''; this.toValue = ''; }
    });
  }

  setValue(dir: string, value: any):void{
    const key = this.filterBase.key;
    const questionIsExist = this.filterBaseService.getQuestion(key)
    if (!value) {
      if (questionIsExist) {
        delete questionIsExist[dir];
        if (!questionIsExist.from && !questionIsExist.to) this.filterBaseService.deleteQuestion(key);
        else this.filterBaseService.addQuestion(key, questionIsExist);
      }
    } else if(questionIsExist == undefined){
      const object = {[dir]:value,range:true};
      this.filterBaseService.addQuestion(key, object);
    }else{
      questionIsExist[dir] = value
      this.filterBaseService.addQuestion(key, questionIsExist);
    }
  };

}
